import { useEffect, useState } from 'react';
import { useMap, useMapEvent } from 'react-leaflet';
import { useSelector } from 'react-redux';

import { useGame } from '../../context';

const useMarkers = () => {
  const lmap = useMap();
  const { clusters } = useGame();
  const pois = useSelector(_ => _.markers);
  const editmode = useSelector(_ => _.editMode);

  const [config, setConfig] = useState({
    bounds: lmap.getBounds(),
    zoom: lmap.getZoom(),
  });

  const [markers, setMarkers] = useState([]);

  useMapEvent('moveend', () => {
    const zoom = lmap.getZoom();
    const bounds = lmap.getBounds();
    setConfig({ bounds, zoom });
  });

  useEffect(() => {
    const { bounds, zoom } = config;
    const categories = clusters[zoom] || clusters['-1'];
    const results = pois
      .filter(({ latlng }) => bounds.contains(latlng))
      .filter(({ category }) => {
        // NOTE Filter markers by category zoom
        // -> do no filter if editmode === true
        if (editmode) return true;
        return categories.includes(category);
      });
    setMarkers(results);
  }, [editmode, pois, config, clusters, lmap]);

  useEffect(() => {
    const zoom = lmap.getZoom();
    const bounds = lmap.getBounds();
    setConfig({ bounds, zoom });
  }, [lmap]);

  return { editmode, markers };
};

export default useMarkers;
